// Apply LZW-compression to a string and return base64 compressed string.
// Strings that contain characters with codepoints > 255 (e.g. Vietnamese,
// Chinese, emoji) are UTF-8 byte-encoded before the LZW step so the algorithm
// only ever sees values 0-255.  The output is prefixed with "~" (not a valid
// base64 character) so myunzip can distinguish this new format from the legacy
// format used by previously-saved sessions.
export function myzip (s) {
    try {
      // Encode to UTF-8 bytes so all char codes are in 0-255.
      const inputBytes = new TextEncoder().encode(s + '')
      let byteStr = ''
      for (let k = 0; k < inputBytes.length; k++) {
        byteStr += String.fromCharCode(inputBytes[k])
      }
      var dict = {}
      var data = byteStr.split('')
      var out = []
      var currChar
      var phrase = data[0]
      var code = 256
      for (var i = 1; i < data.length; i++) {
        currChar = data[i]
        if (dict[phrase + currChar] != null) {
          phrase += currChar
        } else {
          out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
          dict[phrase + currChar] = code
          code++
          phrase = currChar
        }
      }
      out.push(phrase.length > 1 ? dict[phrase] : phrase.charCodeAt(0))
      for (var j = 0; j < out.length; j++) {
        out[j] = String.fromCharCode(out[j])
      }
      // '~' prefix marks the new Unicode-safe format (never appears in base64).
      return '~' + utoa(out.join(''))
    } catch (e) {
      console.log('Failed to zip string return empty string', e)
      return ''
    }
  }
  
  // Decompress an LZW-encoded base64 string.
  // Handles two formats:
  //   '~' prefix  — new Unicode-safe format (UTF-8 byte-encoded before LZW)
  //   no prefix   — legacy format (chars 0-255, produced by the old myzip)
  export function myunzip (base64ZippedString) {
    try {
      const isUnicode = typeof base64ZippedString === 'string' && base64ZippedString.startsWith('~')
      const b64 = isUnicode ? base64ZippedString.slice(1) : base64ZippedString
      var s = atou(b64)
      var dict = {}
      var data = (s + '').split('')
      var currChar = data[0]
      var oldPhrase = currChar
      var out = [currChar]
      var code = 256
      var phrase
      for (var i = 1; i < data.length; i++) {
        var currCode = data[i].charCodeAt(0)
        if (currCode < 256) {
          phrase = data[i]
        } else {
          phrase = dict[currCode] ? dict[currCode] : oldPhrase + currChar
        }
        out.push(phrase)
        currChar = phrase.charAt(0)
        dict[code] = oldPhrase + currChar
        code++
        oldPhrase = phrase
      }
      const byteStr = out.join('')
      if (isUnicode) {
        // Decode the UTF-8 byte string back to a Unicode string.
        const bytes = new Uint8Array(byteStr.length)
        for (let k = 0; k < byteStr.length; k++) {
          bytes[k] = byteStr.charCodeAt(k)
        }
        return new TextDecoder('utf-8').decode(bytes)
      }
      return byteStr
    } catch (e) {
      console.log('Failed to unzip string return empty string', e)
      return ''
    }
  }
  
  // UTF-8 string to base64.
  function utoa (str) {
    try {
      const bytes = new TextEncoder().encode(str)
      let binary = ''
      for (let i = 0; i < bytes.length; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      return window.btoa(binary)
    } catch (e) {
      // Legacy fallback for older browsers.
      return window.btoa(unescape(encodeURIComponent(str)))
    }
  }

  // base64 to UTF-8 string.
  function atou (str) {
    try {
      const binary = window.atob(str)
      const bytes = new Uint8Array(binary.length)
      for (let i = 0; i < binary.length; i++) {
        bytes[i] = binary.charCodeAt(i)
      }
      return new TextDecoder('utf-8').decode(bytes)
    } catch (e) {
      // Legacy fallback for older browsers.
      return decodeURIComponent(escape(window.atob(str)))
    }
  }